import { Link } from "react-router-dom";
import type { Article } from "@/types/news";
import { formatViews, relativeTime } from "@/utils/news";
import CategoryBadge from "@/components/feature/CategoryBadge";

export default function RelatedCard({ article }: { article: Article }) {
  return (
    <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
      <Link to={`/detail/${article.id}`} className="block cursor-pointer">
        <div className="relative h-40 w-full overflow-hidden bg-background-100">
          <img
            src={article.coverImage}
            alt={`${article.title} - 51吃瓜网站相关推荐`}
            title={`${article.title} - 51吃瓜网站`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-4">
          <CategoryBadge categoryKey={article.category} />
          <h3 className="mt-2 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
            {article.title}
          </h3>
          <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
            <span>{relativeTime(article.publishedAt)}</span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(article.views)}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}